import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define the state structure for the signup journey
export interface SignupState {
  currentStep: number;
  accountInfo: {
    email: string;
    password: string;
    terms: boolean;
    accountType: 'trial' | 'prod';
  };
  profileInfo: {
    fullName: string;
    businessName: string;
  };
  locationInfo: {
    registeredAddress: string;
  };
  isSubmitting: boolean;
  error: string | null;
}

const initialState: SignupState = {
  currentStep: 1,
  accountInfo: {
    email: '',
    password: '',
    terms: false,
    accountType: 'trial',
  },
  profileInfo: {
    fullName: '',
    businessName: '',
  },
  locationInfo: {
    registeredAddress: '',
  },
  isSubmitting: false,
  error: null,
};

const signupSlice = createSlice({
  name: 'signup',
  initialState,
  reducers: {
    setCurrentStep: (state, action: PayloadAction<number>) => {
      state.currentStep = action.payload;
    },
    setAccountInfo: (
      state,
      action: PayloadAction<{
        email: string;
        password: string;
        terms: boolean;
        accountType: 'trial' | 'prod';
      }>
    ) => {
      state.accountInfo = action.payload;
    },
    setProfileInfo: (
      state,
      action: PayloadAction<{
        fullName: string;
        businessName: string;
      }>
    ) => {
      state.profileInfo = action.payload;
    },
    setLocationInfo: (
      state,
      action: PayloadAction<{
        registeredAddress: string;
      }>
    ) => {
      state.locationInfo = action.payload;
    },
    setIsSubmitting: (state, action: PayloadAction<boolean>) => {
      state.isSubmitting = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    resetSignupState: () => initialState,
  },
});

export const {
  setCurrentStep,
  setAccountInfo,
  setProfileInfo,
  setLocationInfo,
  setIsSubmitting,
  setError,
  resetSignupState,
} = signupSlice.actions;

export default signupSlice.reducer;
